__turbopack_context__.v({
  "blink": "V4sW4a_blink",
  "liveNow": "V4sW4a_liveNow",
});
